import { useEffect } from "react";
import "@/App.css";
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation,
} from "react-router-dom";

import useReveal from "@/hooks/useReveal";
import Navigation from "@/components/aoria/Navigation";
import Hero from "@/components/aoria/Hero";
import Presentation from "@/components/aoria/Presentation";
import HomeOverview from "@/components/aoria/HomeOverview";
import ManifestoTeaser from "@/components/aoria/ManifestoTeaser";
import Participate from "@/components/aoria/Participate";
import Footer from "@/components/aoria/Footer";

import MentionsLegales from "@/pages/legal/MentionsLegales";
import Confidentialite from "@/pages/legal/Confidentialite";
import Cookies from "@/pages/legal/Cookies";
import Article from "@/pages/Article";
import APropos from "@/pages/APropos";
import Enjeu from "@/pages/Enjeu";
import Outils from "@/pages/Outils";
import FaqPage from "@/pages/Faq";
import Manifeste from "@/pages/Manifeste";
import Ressources from "@/pages/Ressources";
import Partenaires from "@/pages/Partenaires";
import LivreBlanc from "@/pages/LivreBlanc";
import Contact from "@/pages/Contact";
import PourQui from "@/pages/PourQui";
import NotFound from "@/pages/NotFound";
import BackToTop from "@/components/aoria/BackToTop";
import Seo from "@/components/aoria/Seo";

// On home, if URL has a hash like /#participer, scroll to it once mounted
function HashScrollHandler() {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            // small timeout so the section is rendered
            const t = setTimeout(() => {
                const el = document.getElementById(id);
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 60);
            return () => clearTimeout(t);
        }
    }, [location]);
    return null;
}

/**
 * Home — page de synthèse :
 *   1. Hero (identité)
 *   2. Presentation (mission)
 *   3. HomeOverview (6 entrées vers les pages dédiées)
 *   4. ManifestoTeaser (idées centrales + CTA vers /manifeste)
 *   5. Participate (newsletter / bénévolat / contact)
 * Les contenus longs (Stakes, UseCases, FAQ, Manifesto complet, Resources)
 * vivent désormais sur leurs pages propres.
 */
const Home = () => {
    useReveal();
    return (
        <div data-testid="home-page" className="bg-[#FDFDFC] text-[#1B263B]">
            <Seo
                title="Aoria · Accessibilité cognitive à l'ère de l'intelligence artificielle"
                description="Aoria, plateforme de réflexion et de sensibilisation sur l'accessibilité cognitive à l'ère de l'intelligence artificielle : ressources, prises de position, partenariats."
                path="/"
            />
            <HashScrollHandler />
            <Navigation />
            <main>
                <Hero />
                <Presentation />
                <HomeOverview />
                <ManifestoTeaser />
                <Participate />
            </main>
            <Footer />
        </div>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route
                        path="/mentions-legales"
                        element={<MentionsLegales />}
                    />
                    <Route
                        path="/confidentialite"
                        element={<Confidentialite />}
                    />
                    <Route path="/cookies" element={<Cookies />} />
                    <Route path="/a-propos" element={<APropos />} />
                    <Route path="/enjeu" element={<Enjeu />} />
                    <Route path="/outils" element={<Outils />} />
                    <Route path="/faq" element={<FaqPage />} />
                    <Route path="/manifeste" element={<Manifeste />} />
                    <Route path="/ressources" element={<Ressources />} />
                    <Route path="/partenaires" element={<Partenaires />} />
                    <Route path="/livre-blanc" element={<LivreBlanc />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/pour-qui" element={<PourQui />} />
                    <Route path="/ressources/:slug" element={<Article />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
                <BackToTop />
            </BrowserRouter>
        </div>
    );
}

export default App;
